import { useState, useEffect } from "react";
import {
  
  Box, Typography
}
  from "@mui/material"; 

import Careteamlist from "../shared/careteamlist";
import Viewmore from "../shared/viewmore";
import { pcolor } from "../../style2";
// import { Get, Post } from "../../services/api_service";
// import AccessLocalStorage from "../../services/localStorage";
// import {getApiUrl} from "../../services/api_service";

// const useStyles = makeStyles((theme) => ({
//   title: {
//     fontWeight: "bold",
//     fontSize: 16,
//     color: "#001244",
//     paddingLeft: 20,
//   },
//   button: {
//     fontFamily: "Lato",
//     fontStyle: "normal",
//     fontWeight: "normal",
//     fontSize: 14,
//     color: "#FF767E",
//     textTransform: "unset",
//     "&:hover": {
//       background: "#FFFFFF",
//     },
//   },
//   scroll: {
//     overflow: "auto",
//     maxHeight: 315,
//     [theme.breakpoints.down("md")]: {
//       maxHeight: 390,
//     },
//     '&::-webkit-scrollbar': {
//       width: '0.4em',
//     },
//     '&::-webkit-scrollbar-track': {
//       boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
//       webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
//     },
//     '&::-webkit-scrollbar-thumb': {
//       backgroundColor: 'rgba(0,0,0,.1)',
//     },
//     'scrollbar-color': 'rgba(0,0,0,.1) rgba(0,0,0,0)',
//     'scrollbar-width': 'thin',
//   },
// }));

// const title = {
//   fontWeight: "bold",
//   fontSize: 16,
//   color: "#001244",
//   paddingLeft: 20,
// };

// const button = {
//   fontFamily: "Lato",
//   fontStyle: "normal",
//   fontWeight: "normal",
//   fontSize: 14,
//   color: "#FF767E",
//   textTransform: "unset",
//   "&:hover": {
//     background: "#FFFFFF",
//   },
// };

const scroll = {
  overflow: "auto",
  maxHeight: { xs: 315, md: 390 },
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.1)',
  },
  scrollbarColor: 'rgba(0,0,0,.1) rgba(0,0,0,0)',
  scrollbarWidth: 'thin',
};

function HealthCareTeam({ title, team, search, professionalType, list }) {
  //const classes = useStyles();
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [viewMore, setViewMore] = useState(false);


  useEffect(() => {
    setData(list.filter(t => t.professionalType == professionalType));
  }, [list]);


  const handleViewMore = () => {
    viewMore ? setViewMore(false) : setViewMore(true);
    viewMore ? setRowsPerPage(3) : setRowsPerPage(data.length);
  };

  const dataResult = data.filter((val) => {
    if (search === "") {
      return val;
    } else if (
      Object.values(val).join(" ").toLowerCase().includes(search.toLowerCase())
    ) {
      return Object.values(val);
    }
  });

  return (
    <>
      <Typography component="div" sx={{ pl:4, fontWeight:"bold", color: pcolor, fontSize: "20px" }}>{title}</Typography>
      <Box mt={1} />
      <Box sx={{ ...(viewMore && dataResult.length >= 3 ? scroll : {}) }}>
        {dataResult != null && dataResult.length > 0 ? dataResult
          .slice(0, rowsPerPage)
          .map((user) => (
            <div key={user.id}>
              <Careteamlist Pathways={user.pathways}
                IsOrganizationProfessional={user.isOrganizationProfessional}
                Organization={user.organization} Title={user.title}
                FirstName={user.name} Service={user.serviceDepartment} />
            </div>
          )) : <Box component="div">
          <Typography sx={{ paddingLeft: "20px" }}>No Team Members</Typography>
        </Box>}
      </Box>
      <Box display='flex' justifyContent='flex-end' sx={{paddingRight: 3, paddingTop: 1 }}>
        {data.length >= 3 && dataResult.length >= 3 ? (
          <Viewmore handleViewMore={handleViewMore}></Viewmore>
        ) : null}
      </Box>
    </>
  );
}

export default HealthCareTeam;
